import React from "react";
import PdfPage from "../components/PdfPage";
import "./index.css";

const DisputeAndArbitation = () => {
  return (
    <main>
      <PdfPage
        h2={"Dispute Resolution/Arbitration"}
        img={"/img/dispute-and-arbitation.jpg"}
        pdf1={"https://api.orbitsecurities.com.pk/media/cms/documents/dispute-resolution-and-arbitration-english.pdf"}
        pdf1Text={"Download  In English"}
        pdf2={"https://api.orbitsecurities.com.pk/media/cms/documents/dispute-resolution-and-arbitration-urdu.pdf"}
        pdf2Text={"Download In Urdu"}
      />
    </main>
  );
};

export default DisputeAndArbitation;
